import { FC, KeyboardEvent as ReactKeyboardEvent, useEffect, useRef } from 'react';

import { keyboardKeys, keyboardMatches } from '@hh.ru/magritte-common-keyboard';
import { useMultipleRefs } from '@hh.ru/magritte-common-use-multiple-refs';
import { ActionListProps } from '@hh.ru/magritte-ui-action-list/types';
import { BottomSheet } from '@hh.ru/magritte-ui-bottom-sheet';
import { Drop } from '@hh.ru/magritte-ui-drop';
import { VSpacing } from '@hh.ru/magritte-ui-spacing';

export const ActionList: FC<ActionListProps> = ({ children, dropProps, bottomSheetProps, visible, ...commonProps }) => {
    const closedByKeyboardRef = useRef(false);
    const dropRef = useRef<HTMLElement>(null);
    const dropRefCallback = useMultipleRefs(dropRef, dropProps.ref);

    useEffect(() => {
        if (!visible) {
            if (closedByKeyboardRef.current && dropProps.activatorRef.current !== null) {
                dropProps.activatorRef.current.focus();
            }
            closedByKeyboardRef.current = false;
        }
    }, [dropProps.activatorRef, visible]);

    return (
        <>
            <Drop
                {...dropProps}
                {...commonProps}
                autoFocusWhenOpened
                keyboardNavigationMode="list"
                onKeyDownCapture={(event: ReactKeyboardEvent) => {
                    if (
                        keyboardMatches(event.nativeEvent, [
                            keyboardKeys.Enter,
                            keyboardKeys.Escape,
                            keyboardKeys.Space,
                        ])
                    ) {
                        closedByKeyboardRef.current = true;
                    }
                }}
                ref={dropRefCallback}
                space={400}
                visible={visible}
            >
                {children}
            </Drop>
            <BottomSheet {...bottomSheetProps} {...commonProps} height="content" visible={visible}>
                {children}
                <VSpacing default={16} />
            </BottomSheet>
        </>
    );
};

ActionList.displayName = 'ActionList';
